import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Intentional empty / placeholder presentation shared by the note tabs. */
@Component({
  selector: 'app-note-empty-state',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex flex-col items-center justify-center gap-2 px-6 py-14 text-center text-(--p-text-muted-color)">
      <span class="material-symbols-outlined !text-5xl" aria-hidden="true">{{ icon() }}</span>
      <p class="m-0 text-base font-medium text-(--p-text-color)">{{ title() }}</p>
      @if (description()) {
        <p class="m-0 max-w-sm text-sm">{{ description() }}</p>
      }
      <ng-content />
    </div>
  `,
})
export class NoteEmptyStateComponent {
  readonly icon = input('inbox');
  readonly title = input.required<string>();
  readonly description = input('');
}
